import {
    Block,
    CHILD_OBJECT_INVALID,
    CHILD_REQUIRED,
    CHILD_TYPE_INVALID,
    PARENT_OBJECT_INVALID,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_PARAGRAPH, BLOCK_TABS, BLOCK_TABS_ITEM } from '../types';
import { unwrapChildren } from '../utils';

/*
 * Schema to validate tabs.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_TABS]: {
            parent: { objects: ['document', 'block', 'fragment'] },
            nodes: [{ types: [BLOCK_TABS_ITEM] }],
            data: {
                // @deprecated Per-block width is no longer consumed by the editor or renderer
                fullWidth: (fullWidth) =>
                    typeof fullWidth === 'undefined' || typeof fullWidth === 'boolean',
            },
            isVoid: false,
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_TYPE_INVALID]: (change, context) => {
                    return change.wrapBlockByKey(
                        context.child.key,
                        Block.create({ type: BLOCK_TABS_ITEM })
                    );
                },
            }),
        },
        [BLOCK_TABS_ITEM]: {
            parent: { types: [BLOCK_TABS] },
            nodes: [{ objects: ['block'], min: 1 }],
            isVoid: false,
            data: {
                title: (title) => title === undefined || typeof title === 'string',
                icon: (icon) => icon === undefined || typeof icon === 'string',
                slug: (slug) => slug === undefined || typeof slug === 'string',
            },
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_OBJECT_INVALID]: (change, context) => {
                    if (context.child.object === 'text') {
                        return change.wrapBlockByKey(
                            context.child.key,
                            Block.create({
                                type: BLOCK_PARAGRAPH,
                            })
                        );
                    }
                },
                [CHILD_REQUIRED]: (change, context) => {
                    const block = context.node;
                    if (Block.isBlock(block)) {
                        change.insertNodeByKey(block.key, 0, createParagraph());
                    }
                },
            }),
        },
    },
});
